import React from 'react'

function DatosPlaza() {
  return (
    <>
     <div className="datoPlaza">
                  <h2>69 mil</h2>
                  <p>Plazas</p>
                </div>
    <div className="datoPlaza">
                <h2>54 mil</h2>
                <p>Trabajadores</p>
    </div>
    </>
  )
}

export default DatosPlaza